/// 通用类型，非通用的不要声明在这里

/** 通用 Map 泛型，为了与新标准中的 Map 类相区分，这里使用名称 MapType */
export interface MapType<T = string> {
  [key: string]: T
  [index: number]: T
}

/** 可取消的事件 */
export interface CancelableEvent {
  canceled: boolean
}

/**
 * ajax 调用结果
 */
export interface AjaxResult {
  s: number
  data: any
  msg: string
}

/**
 * 含有 id、name 的类型
 */
export interface IdName {
  id: number
  name: string
}

/**
 * 3d 模型 - 自然属性 - 分类
 */
export interface GeneralCate extends IdName {
  subCate: IdName[]
}

/**
 * 学段带学科
 */
export interface PhaseWithSubject extends IdName {
  subject: IdName[]
}

/**
 * 语言
 */
export type Language = 'en_us' | 'zh_cn'

/**
 * 区域
 */
export type Locale = 'en' | 'zh'

/**
 * 用户信息
 */
export interface User {
  id: number
  username: string
  nickname: string

  /** 角色，TODO: 完善类型 */
  role: number

  /** 学校 id? */
  sid: number
}

/**
 * 学校信息
 */
export interface School {
  name: string
  logo: string
  school_key: string
}

/**
 * 列表类型
 * 这里的数字不要随意更改，数字除以 10 的商，就是 Item 中的 type
 */
export enum ListType {
  /** 云端课程 */
  cloudCourse = 10,

  /** 我的课程 */
  myCourse = 11,

  /** 云端资源 */
  cloudResource = 20,

  /** 我的资源 */
  myResource = 21
}

/**
 * 列表项类型
 */
export enum ItemType {
  /** 课程 */
  course = 1,

  /** 资源 */
  resource = 2
}

/**
 * 列表项数据
 */
export interface ItemData {
  // 类型
  type: ItemType

  // id
  id: number

  // 封面
  cover: string

  // 标题
  title: string

  // 资源
  count: number

  // 是否隐藏去上课
  hidePlay?: boolean

  // 是否隐藏编辑（包含删除）
  hideEdit?: boolean

  // 是否隐藏加入课程
  hideAdd?: boolean
}

/**
 * 资源项
 */
export interface ResourceItem {
  // id
  id: number

  // 封面
  cover: string

  // 标题
  title: string
}

/**
 * 班级
 */
export interface ClassItem {
  id: number
  name: string
}

/**
 * 设备
 */
export interface DeviceItem {
  id: number
  name: string
  cmdMode: boolean
  isDownload: boolean
  isMute: boolean
  isOnline: boolean
  isPlay: boolean
  lowBattery: boolean
  eyeUrl: string
}

/**
 * 播放器状态
 */
export enum PlayerStatus {
  /** 显示播放按钮状态 */
  play,
  /** 显示暂停按钮状态 */
  pause,
  /** 显示停止按钮状态 */
  stop
}
